module.exports = __webpack_public_path__ + "img/BOC-logo.f40fdfca.png";